import request from '../utils/Request';
import { Methods, NotificationType } from '../config';
import { downloadFile } from '../utils/download';
import addNotification from '../utils/addNotification';
import { ResponseType } from '../config/responetype';
import dayjs from 'dayjs';

const baseURL = 'employeeAttendance';

const employeeAttendenceService = {
  getRows: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/rows`,
      data,
    });
  },

  createRow: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateRow: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  deleteRow: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  getOrderNumber: (projectId) => {
    return request({
      resource: `${baseURL}/orderNumber/${encodeURIComponent(projectId)}`,
    });
  },

  updateBatchedStatus: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/batchedStatus`,
      data,
    });
  },

  getExcelTemplate: async () => {
    const excelFromServer = await request({
      responseType: 'blob',
      resource: `${baseURL}/exceltemplate`,
    });
    return downloadFile(excelFromServer, `dolgozoi_jelenlet_template-${dayjs().format('YYYYMMDD_HHmm')}.xlsx`);
  },

  importExcel: async (files, userId) => {
    const formData = new FormData();

    for (const file of files) {
      formData.append('files', file);
    }
    formData.append('userId', userId);

    const resp = await request({
      method: Methods.POST,
      resource: `${baseURL}/excelimport`,
      formData: true,
      data: formData,
      responseType: 'blob',
    });

    if (resp?.type === ResponseType.xlsx) {
      addNotification({
        content: 'Az import sikertelen!',
        type: NotificationType.ERROR,
      });

      downloadFile(resp, `ERR_${files[0].name}`);
      return Promise.reject(new Error('Error in uploaded file!'));
    }

    const reader = new FileReader();
    reader.readAsText(resp);
    reader.onload = () => {
      const jsonData = JSON.parse(reader.result);
      if (jsonData?.error?.message) {
        return addNotification({
          content: jsonData.error.message,
          type: NotificationType.ERROR,
        });
      }
      return jsonData.data;
    };
  },
};

export default employeeAttendenceService;
